import constants from "./constants";
import getApiHeaders from './apiHeaders.js';

const fetchNodeContent = async (topic, subtopic = '', start = false) => {
    const response = await fetch(
        `${constants.fetchNodeContent}?topic=${topic}${subtopic ? '&subtopic=' + subtopic : ''}`, {
        method: 'GET',
        headers: getApiHeaders(),
        credentials: "include"
    });

    if (!response.ok) {
        response.message = await response.json();
        throw response;
    }

    return await response.json();
}

export default fetchNodeContent